import './GameCard.scss';
import '../../pages/profile/GamesPlayed.scss';

import { ENTER_KEY_CODE, IGDB, gameExperiences } from '../../utils/constants';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { GameExperience } from '../../models/survey';
import { getGameDisplayString } from '../../utils/generic';
import iconAnimation from '../../assets/images/ubisoft-playtest-profile-icon-person-running-black.webp';
import iconCollaboration from '../../assets/images/ubisoft-playtest-profile-icon-group-people-black.webp';
import iconFlag from '../../assets/images/ubisoft-playtest-profile-icon-flag-black.webp';
import iconSmiley from '../../assets/images/ubisoft-playtest-profile-icon-smiley-black-with-padding.webp';
import iconSupport from '../../assets/images/ubisoft-playtest-profile-icon-hands-holding-black.webp';
import { isUndefined } from 'lodash';
import messages from '../GameModal/messages';
import noImage from '../../assets/images/ubisoft-playtest-icon-game-no-picture.webp';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface OwnProps {
  gameExperience: GameExperience;
  onEdit: (id: string) => void;
}

const GameCard = (props: OwnProps) => {
  const intl = useIntl();

  const getYesNoText = (value: boolean) =>
    value
      ? intl.formatMessage({ ...siteMessages.YES })
      : intl.formatMessage({ ...siteMessages.NO });

  const getSelectText = (value: number | undefined) => {
    if (isUndefined(value)) return '-';
    const experience = gameExperiences.find((e) => e.id === value)!.name;
    // eslint-disable-next-line
    // @ts-ignore
    return intl.formatMessage({ ...messages[experience] });
  };

  const onEdit = () => {
    props.onEdit(props.gameExperience.id);
  };

  return (
    <div className="card game-card">
      <div className="title">
        <div
          className="edit"
          onClick={onEdit}
          tabIndex={0}
          onKeyDown={(e: any) => {
            if (e.keyCode == ENTER_KEY_CODE) e.target.click();
          }}
        >
          {intl.formatMessage({ ...siteMessages.edit })}
        </div>
        <div className="name">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={props.gameExperience.id} className="tooltip">
                {props.gameExperience.game.name}
              </Tooltip>
            }
          >
            <h4>{getGameDisplayString(props.gameExperience)}</h4>
          </OverlayTrigger>
        </div>
        <img
          src={`${IGDB.baseURL}${props.gameExperience.game.imageId}`}
          alt={props.gameExperience.game.name}
          onError={(e: any) => {
            e.target.src = noImage;
          }}
        />
      </div>
      {props.gameExperience.game.singlePlayerMode && (
        <div className="info">
          <img src={iconAnimation} alt="" />
          <div>
            <p className="fw-bold">
              {intl.formatMessage({ ...messages.singlePlayer })}
            </p>
            <p>{getSelectText(props.gameExperience.singleExperienceId)}</p>
          </div>
        </div>
      )}
      {props.gameExperience.game.multiplayerMode && (
        <div className="info">
          <img src={iconCollaboration} alt="" />
          <div>
            <p className="fw-bold">
              {intl.formatMessage({ ...messages.multiPlayer })}
            </p>
            <p>{getSelectText(props.gameExperience.multiExperienceId)}</p>
          </div>
        </div>
      )}
      {props.gameExperience.game.coopMode && (
        <div className="info">
          <img src={iconSupport} alt="" />
          <div>
            <p className="fw-bold">
              {intl.formatMessage({ ...messages.coop })}
            </p>
            <p>{getSelectText(props.gameExperience.coopExperienceId)}</p>
          </div>
        </div>
      )}
      <div className="info">
        <img src={iconSmiley} alt="" />
        <div>
          <p className="fw-bold">
            {intl.formatMessage({ ...messages.likeGame })}
          </p>
          <p>
            {isUndefined(props.gameExperience.liked)
              ? '-'
              : getYesNoText(props.gameExperience.liked)}
          </p>
        </div>
      </div>
      <div className="info">
        <img src={iconFlag} alt="" />
        <div>
          <p className="fw-bold">
            {intl.formatMessage({ ...messages.finishGame })}
          </p>
          <p>
            {isUndefined(props.gameExperience.finished)
              ? '-'
              : getYesNoText(props.gameExperience.finished)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default GameCard;
